import React from 'react'

export default function CrispIframe({ WEBSITE_ID }: { WEBSITE_ID?: string }) {
  return !!WEBSITE_ID && (
    <div className="flex rounded border w-full">
      <iframe
        src={`https://go.crisp.chat/chat/embed/?website_id=${WEBSITE_ID}`}
        style={{
          height: '415px',
          margin: '0',
          padding: '0',
          width: '100%',
        }}
      />
    </div>
  )
}
